import {connectRouter, routerMiddleware} from 'connected-react-router';
import {applyMiddleware, combineReducers, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';

import history from '../history';

import logger from './middleware/logger';

import appStateReducer from './reducers/app-state-reducer';
import featureSourcesReducer from './reducers/feature-sources-reducer';
import tagHierarchyStateReducer from './reducers/tag-hierarchy-reducer';

const middleware = composeWithDevTools(
	applyMiddleware(routerMiddleware(history), logger)
);

const rootReducer = combineReducers({
	// lastAction: (_, action) => action, // remembers the action to be accessed by store subscribers
	router: connectRouter(history),
	app: appStateReducer,
	tagHierarchy: tagHierarchyStateReducer,
	featureSources: featureSourcesReducer,
});

export default createStore(rootReducer, {}, middleware);
